import { Outlet } from 'react-router'

import CurbsNav from '@/components/layouts/CurbsNav'
import GlobalModal from '@/modules/globalModal'

const NavigationLayoutMUI = () => (
  <>
    <GlobalModal />
    {/* CurbsNav wraps the page in the scroller that its width pushes aside. */}
    <CurbsNav>
      <Outlet />
    </CurbsNav>
  </>
)
export default NavigationLayoutMUI
